"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FooterSection = exports.HeaderSection = void 0;
var react_1 = __importDefault(require("react"));
function HeaderSection(props) {
    return (react_1.default.createElement("div", { style: { whiteSpace: 'pre-wrap' }, className: "w-100" },
        react_1.default.createElement("strong", null,
            props.content,
            " on ",
            props.date)));
}
exports.HeaderSection = HeaderSection;
;
function FooterSection(props) {
    return (react_1.default.createElement("div", { className: "relative pv1" },
        react_1.default.createElement("div", { style: { whiteSpace: 'pre-wrap' } }, props.content ? props.content : "")));
}
exports.FooterSection = FooterSection;
;
//# sourceMappingURL=HeaderAndFooter.js.map